import { useContext } from 'react';
import { AuthContext } from '../contexts';
const useAuthUser = () => {
    const { user } = useContext(AuthContext);
    return user;
};
export default useAuthUser;
//# sourceMappingURL=useAuthUser.js.map